import { AppManifest } from './AppManifest';

export const PageTitles = {
  Home: `${AppManifest.EnvironmentMoniker}PLB Merchant Portal - Home`,
  GetToKnow: `${AppManifest.EnvironmentMoniker}Get to know the SmartCard`,
  RestrictedItems: `${AppManifest.EnvironmentMoniker}Restricted items`,
  AccreditedPOSProviders: `${AppManifest.EnvironmentMoniker}Accredited POS Providers`,
  WhatIsProductLevelBlocking: `${AppManifest.EnvironmentMoniker}What is Product Level Blocking`,
  GoingLiveWithProductLevelBlocking: `${AppManifest.EnvironmentMoniker}Going live with Product Level Blocking`,
  YourBusiness: `${AppManifest.EnvironmentMoniker}Your business and the SmartCard`,
  Definitions: `${AppManifest.EnvironmentMoniker}PLB glossary`,
  Compatibility: `${AppManifest.EnvironmentMoniker}Elibility`,
  FrequentlyAskedQuestions: `${AppManifest.EnvironmentMoniker}Frequently Asked Questions`,
  ContactUs: `${AppManifest.EnvironmentMoniker}Contact Us`,
  SignUpForProductLevelBlocking: `${AppManifest.EnvironmentMoniker}Sign up for Product Level Blocking`,
  MerchantParticipationAgreement: `${AppManifest.EnvironmentMoniker}Merchant Participation Agreement`
}


